import React from "react";

const Dropdown = ({
  id,
  data,
  onchange,
  label,
  value,
  isRequired = false,
}: {
  id: any;
  data: any;
  onchange?: any;
  label?: any;
  value?: any;
  isRequired?: boolean;
}) => {
  return (
    <select
      id={id}
      name={id}
      onChange={(e: any) => onchange(e.target.value)}
      className="shadow-none d-inline-block"
      style={{
        backgroundColor: "white",
        border: "solid 1px #e4e4e4",
        borderRadius: "0px",
        width: "100%",
        fontFamily: "Saira",
        fontSize: "16px",
        color: "#6d6e71",
      }}
    >
      <option value="">Select {id}</option>
      {data.map((val: any) => {
        let selected = val.id == value ? "selected" : "";
        return (
          <>
            {selected ? (
              <option value={val.id} selected>
                {val.name}
              </option>
            ) : (
              <option value={val.id}>{val.name}</option>
            )}
          </>
        );
      })}
    </select>
  );
};

export default Dropdown;
